// ExampleComponent.tsx
import React from 'react';
import SvgIcon from '../core/SvgIcon';
import { ReactComponent as Icon }  from '../../assets/icons/draw-polygon.svg';

const DrawPolygon = ({
    width = 24,
    height = 24,
    fill = "#666666"
}) => <SvgIcon Icon={Icon} width={width} height={height} fill={fill} />;

export default DrawPolygon;
